export function runBlock($animate, $transitions, $rootScope, $mdDateLocale, $filter, CacheBusterService) {
    'ngInject';

    const isIE = window.document.documentMode;
    if (isIE) $animate.enabled(false);

    CacheBusterService.checkVersion();

    $mdDateLocale.formatDate = date => $filter('fsDateCalendar')(date);

    /* eslint-disable angular/on-watch */
    $rootScope.$on('$translateChangeSuccess', function () {
        $rootScope.i18nLoaded = true;
    });

    $transitions.onStart({}, (transition) => {
        const stateParams = transition.to().params;
        $rootScope.pageTitle = stateParams ? stateParams.pageTitle : null;
        return true;
    });
}
